module.exports = __webpack_public_path__ + "img/destinations-africa.f7aa1007.webp";